import { useNavigate } from 'react-router-dom';
import { Table, StatusBadge, ActionCell, Button } from '@components/ui';
import { Home, Trash2, Edit } from 'lucide-react';
import { statusLabels, statusColors, paymentTypeLabels } from '@mocks/daireler';

export default function DaireTablosu({ data, onEdit, onDelete }) {
    const navigate = useNavigate();

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return '-';
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0,
        }).format(amount);
    };

    const columns = [
        {
            key: 'blockName',
            header: 'Blok',
            width: 'xs',
            render: (val) => <span className="font-medium text-primary">{val}</span>,
        },
        {
            key: 'floor',
            header: 'Kat',
            width: 'xs',
            align: 'center',
        },
        {
            key: 'number',
            header: 'Daire No',
            width: 'sm',
            render: (val) => <span className="font-semibold">{val}</span>,
        },
        {
            key: 'grossM2',
            header: 'Brüt m²',
            width: 'xs',
            align: 'right',
            render: (val) => `${val} m²`,
        },
        {
            key: 'netM2',
            header: 'Net m²',
            width: 'xs',
            align: 'right',
            render: (val) => `${val} m²`,
        },
        {
            key: 'unitPrice',
            header: 'Birim ₺/m²',
            width: 'sm',
            align: 'right',
            render: (val) => formatCurrency(val),
        },
        {
            key: 'totalPrice',
            header: 'Toplam Fiyat',
            width: 'md',
            align: 'right',
            render: (val) => <span className="font-semibold">{formatCurrency(val)}</span>,
        },
        {
            key: 'status',
            header: 'Durum',
            width: 'sm',
            align: 'center',
            render: (val) => (
                <StatusBadge
                    status={statusLabels[val] || val}
                    variant={statusColors[val] || 'default'}
                />
            ),
        },
        {
            key: 'buyerName',
            header: 'Alıcı',
            width: 'lg',
            render: (val, row) => val ? (
                <button
                    className="text-primary hover:underline text-left"
                    onClick={() => navigate(`/finans/musteriler/${row.buyerId}`)}
                >
                    {val}
                </button>
            ) : <span className="text-text-muted">-</span>,
        },
        {
            key: 'paymentType',
            header: 'Ödeme',
            width: 'sm',
            align: 'center',
            render: (val) => val ? (
                <StatusBadge
                    status={paymentTypeLabels[val] || val}
                    variant={val === 'pesin' ? 'success' : val === 'taksit' ? 'info' : 'tertiary'}
                />
            ) : '-',
        },
        {
            key: 'paidAmount',
            header: 'Ödenen',
            width: 'md',
            align: 'right',
            render: (val, row) => row.status !== 'available' && val > 0 ? (
                <span className="text-success">{formatCurrency(val)}</span>
            ) : '-',
        },
        {
            key: 'remainingAmount',
            header: 'Kalan',
            width: 'md',
            align: 'right',
            render: (val, row) => row.status !== 'available' && val > 0 ? (
                <span className="text-warning font-medium">{formatCurrency(val)}</span>
            ) : '-',
        },
        {
            key: 'actions',
            header: '',
            width: 'xs',
            align: 'center',
            render: (val, row) => (
                <ActionCell>
                    <Button
                        variant="ghost"
                        size="xs"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit?.(row);
                        }}
                    >
                        <Edit size={14} />
                    </Button>
                    <Button
                        variant="ghost-error"
                        size="xs"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete?.(row);
                        }}
                    >
                        <Trash2 size={14} />
                    </Button>
                </ActionCell>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            data={data}
            striped
            hover
            compact
            showRowNumbers
            emptyMessage="Daire bulunamadı."
            emptyIcon={<Home size={40} />}
        />

    );
}
